export default __webpack_public_path__ + "static/media/3612.88cad394.png";